import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router';
import { CalendarCheck, House, ListBullets } from '@phosphor-icons/react';
import { Glass } from './Glass';
import { savedBookings } from '../lib/local';

/** Glass bottom navigation. Pages reserve its height (see .app-page). */
export function BottomNav({ slug }: { slug: string }) {
  const base = `/s/${slug}`;
  const { pathname } = useLocation();
  const [hasBookings, setHas] = useState(() => savedBookings(slug).length > 0);
  useEffect(() => {
    const l = () => setHas(savedBookings(slug).length > 0);
    window.addEventListener('studio-bookings', l);
    return () => window.removeEventListener('studio-bookings', l);
  }, [slug]);
  const items = [
    { to: `${base}/`, label: 'Главная', icon: House, end: true },
    { to: `${base}/services`, label: 'Услуги', icon: ListBullets },
    { to: `${base}/my`, label: 'Моя запись', icon: CalendarCheck, dot: hasBookings },
  ];
  return (
    <nav className="bottom-nav-wrap" aria-label="Основная навигация">
      <Glass className="bottom-nav" zIndex={1} frost={14} tint="rgba(6, 8, 12, 0.74)" refreshKey={pathname}>
        {items.map((it) => {
          const active = it.end ? pathname === it.to || pathname === base : pathname.startsWith(it.to);
          return (
            <NavLink key={it.to} to={it.to} end={it.end} aria-current={active ? 'page' : undefined}>
              <it.icon size={24} weight={active ? 'fill' : 'regular'} aria-hidden />
              <span>{it.label}</span>
              {it.dot && <span className="bottom-nav__badge" aria-label="есть запись" />}
            </NavLink>
          );
        })}
      </Glass>
    </nav>
  );
}
